import React from "react";
import { Flex, Text } from "@fluentui/react-northstar";

const AVAILABILITY_COLORS = {
    Available: "#107c10",
    Busy: "#d13438",
    InACall: "#d13438",
    InAMeeting: "#d13438",
    InAConferenceCall: "#d13438",
    Presenting: "#d13438",
    Away: "#F7A827",
    BeRightBack: "#F7A827",
    DoNotDisturb: "#7c3aed",
    Offline: "#8a8a8a",
    PresenceUnknown: "#8a8a8a",
};

const AVAILABILITY_LABELS = {
    Available: "Verfügbar",
    Busy: "Beschäftigt",
    Away: "Abwesend",
    DoNotDisturb: "Nicht stören",
    Offline: "Offline",
    BeRightBack: "Bin gleich zurück",
    PresenceUnknown: "Unbekannt",
};

const ACTIVITY_LABELS = {
    InACall: "In einem Anruf",
    InAMeeting: "In einer Besprechung",
    InAConferenceCall: "In einer Konferenz",
    Presenting: "Präsentiert",
};

function getColor(availability) {
    return AVAILABILITY_COLORS[availability] || "#8a8a8a";
}

function getLabel(availability) {
    return AVAILABILITY_LABELS[availability] || "Unbekannt";
}

function getActivityLabel(activity) {
    return ACTIVITY_LABELS[activity] || null;
}

function PresenceBadge({ availability, activity, dotOnly }) {
    const color = getColor(availability);
    const label = getLabel(availability);
    const activityLabel = activity && activity !== availability ? getActivityLabel(activity) : null;
    const tooltipText = activityLabel ? `${label} – ${activityLabel}` : label;

    if (dotOnly) {
        return (
            <div
                title={tooltipText}
                style={{
                    position: "absolute",
                    bottom: 0,
                    right: 0,
                    width: 12,
                    height: 12,
                    borderRadius: "50%",
                    backgroundColor: color,
                    border: "2px solid #fff",
                    boxSizing: "border-box",
                }}
            />
        );
    }

    return (
        <Flex gap="gap.smaller" vAlign="center" wrap>
            <div
                style={{
                    width: 8,
                    height: 8,
                    borderRadius: "50%",
                    backgroundColor: color,
                    flexShrink: 0,
                }}
            />
            <Flex column>
                <Text size="small" content={label} />
                {activityLabel && (
                    <Text
                        size="small"
                        content={activityLabel}
                        styles={{ fontStyle: "italic" }}
                    />
                )}
            </Flex>
        </Flex>
    );
}

export default PresenceBadge;
